module.exports = __webpack_public_path__ + "static/media/giphy.0d7b312d.gif";